import axios from 'axios';
import { API_BASE_URL, config } from '../constants/api';

export const fetchTansectionList = async ({type,id}) => {
    console.log("type",type,id)
  const res = await axios.get(`${API_BASE_URL}/transaction/${type=="transactions-all" ? "get-all-transection" : type=="transactions-app" ? `get-transection-by-app-id/${id ? id :""}` :`get-transection/${id}`}`,config);
  return res.data;
};